/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/upload_medium'
export default icon
